import { useHistory, useLocation, useParams } from 'quartz-routing/react-router';
import { HUBSPOT_SOFTWARE_INDEX } from './wizardTypes';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
export const useWizardParams = () => {
  const {
    categoryGroup,
    category,
    certsOnly
  } = useParams();
  const isToolsSelected = useLocation().pathname.includes(HUBSPOT_SOFTWARE_INDEX);
  return {
    isToolsSelected,
    categoryGroup,
    category,
    showOnlyCerts: certsOnly === undefined ? undefined : certsOnly === 'true'
  };
};
export const useWizardNavigation = () => {
  const history = useHistory();
  const {
    isToolsSelected,
    categoryGroup,
    category,
    showOnlyCerts
  } = useWizardParams();
  const currentPath = [WIZARD_URL_FRAGMENT, isToolsSelected ? HUBSPOT_SOFTWARE_INDEX : undefined, categoryGroup, category, showOnlyCerts].filter(e => e !== undefined);
  const goForward = option => history.push(Object.assign({}, history.location, {
    pathname: [...currentPath, option].join('/')
  }));
  const goBack = () => history.push(Object.assign({}, history.location, {
    pathname: [...currentPath.slice(0, currentPath.length - 1)].join('/')
  }));
  return {
    goForward,
    goBack
  };
};